// window.eventKeywords = ['scroll', 'wheel', 'mouse', 'focus', 'qsk', 'lazy', 'page', 'load', 'click', 'transition', 'readystatechange', 'message', 'animationend', 'blur']
// window.checkIncludes = ev => !!window.eventKeywords.find(e => ev.type.toLowerCase().includes(e));
// (function() {
//   const _addEventListener = EventTarget.prototype.addEventListener;

//   EventTarget.prototype.addEventListener = function(type, listener, options) {
//     const wrappedListener = function(event) {
//       if(!checkIncludes(event)) {
//         console.log(`[Event Fired] type: ${event.type}, target:`, event.target);
//       }
//       return listener.call(this, event);
//     };
    
//     return _addEventListener.call(this, type, wrappedListener, options);
//   };
// })();

(function () {
  var sourceSelector = '.t4s-product-price .t4s-badge-price';
  var badgeSelector = '.t4s-single-product-badge [data-badge-sale]';

  var timer = null;
  var lastText = '';
  var isSyncing = false;

  function getSourceText() {
    var source = document.querySelector(sourceSelector);
    return source ? source.innerText.trim() : '';
  }

  function getBadges() {
    return document.querySelectorAll(badgeSelector);
  }

  function syncSaleBadges() {
    if (isSyncing) return;

    isSyncing = true;

    var text = getSourceText();

    if (text) {
      lastText = text;
    }

    getBadges().forEach(function (badge) {
      var nextText = text || lastText;

      if (nextText && badge.innerText.trim() !== nextText) {
        badge.innerText = nextText;
      }
    });

    isSyncing = false;
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(syncSaleBadges, 0);
  }

  syncSaleBadges();

  new MutationObserver(function () {
    scheduleSync();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener('variant:change', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
})();

// move .t4s-shipping-list
document.addEventListener('DOMContentLoaded', () => {
  moveElementAfter('.t4s-shipping-list', '.template-product .t4s-product-tabs-wrapper');
});
const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};